import { Anchor, Link } from "@faire/web--source/ui/LinkAnchor";
import styled, { css } from "styled-components";
export var AccessibilityLinkCss = css([
    "&:focus-visible{outline:solid;outline:revert;}"
]);
export var AccessibilityLink = styled(Link).withConfig({
    componentId: "sc-e144a862-0"
})([
    "",
    ""
], AccessibilityLinkCss);
export var AccessibilityAnchor = styled(Anchor).withConfig({
    componentId: "sc-e144a862-1"
})([
    "",
    ""
], AccessibilityLinkCss);
